module.exports = __webpack_public_path__ + "img/image_05.f89d6fa4.png";